import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
  .set('Response', new Immutable.Map({}))
  .set('Search', new Immutable.List([]))
  .set('GetListChangeDestinity', new Immutable.List([]))
  .set('GetDetailsChangeDestinity', new Immutable.Map({}))
  .set('GetSupervisorChangeDest', new Immutable.List([]))
  .set('GetDirectorChangeDest', new Immutable.List([]))
  .set('GetMontosChangeDest', new Immutable.List([]))
  .set('Save', new Immutable.Map({}))
  .set('update_status', new Immutable.Map({}))
  .set('update_status_cambio', new Immutable.Map({}))
	.set('get_report_change_destination', new Immutable.List([]))
	.set('get_monto_autorizado', new Immutable.Map([]))
	.set('get_authorized_date', new Immutable.Map([]))

/* Types */

export const ACTION_GET_LIST_CHANGE = 'ACTION_GET_LIST_CHANGE'
export const ACTION_GET_LIST_DETAILS_CHANGE = 'ACTION_GET_LIST_DETAILS_CHANGE'
export const ACTION_GET_LIST_SUPERVISOR_CHANGE = 'ACTION_GET_LIST_SUPERVISOR_CHANGE'
export const ACTION_GET_LIST_DIRECTOR_CHANGE = 'ACTION_GET_LIST_DIRECTOR_CHANGE'
export const ACTION_GET_MONTOS_CHANGE = 'ACTION_GET_MONTOS_CHANGE'
export const ACTION_SAVE_CHANGE = 'ACTION_SAVE_CHANGE'
export const ACTION_UPDATE_STATUS = 'ACTION_UPDATE_STATUS'
export const ACTION_UPDATE_STATUS_CHANGE = 'ACTION_UPDATE_STATUS_CHANGE'
export const ACTION_GET_REPORT_CHANGE_DESTINATION = 'ACTION_GET_REPORT_CHANGE_DESTINATION'
export const ACTION_GET_MONTO_AUTORIZADO = 'ACTION_GET_MONTO_AUTORIZADO'
export const ACTION_GET_AUTHORIZED_DATE = 'ACTION_GET_AUTHORIZED_DATE'

/* Reducer */
export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_GET_LIST_CHANGE:
      return state.set('GetListChangeDestinity', new Immutable.List(action.Obj))
    case ACTION_GET_LIST_DETAILS_CHANGE:
      return state.set('GetDetailsChangeDestinity', new Immutable.Map(action.Obj))
    case ACTION_GET_LIST_SUPERVISOR_CHANGE:
      return state.set('GetSupervisorChangeDest', new Immutable.List(action.Obj))
    case ACTION_GET_LIST_DIRECTOR_CHANGE:
      return state.set('GetDirectorChangeDest', new Immutable.List(action.Obj))
    case ACTION_GET_MONTOS_CHANGE:
      return state.set('GetMontosChangeDest', new Immutable.List(action.Obj))
    case ACTION_SAVE_CHANGE:
      return state.set('Save', new Immutable.Map(action.Obj))
    case ACTION_UPDATE_STATUS:
      return state.set('update_status', new Immutable.Map(action.Obj))
    case ACTION_UPDATE_STATUS_CHANGE:
      return state.set('update_status_cambio', new Immutable.Map(action.Obj))
		case ACTION_GET_REPORT_CHANGE_DESTINATION:
			return state.set('get_report_change_destination', new Immutable.Map(action.Obj))
		case ACTION_GET_MONTO_AUTORIZADO:
			return state.set('get_monto_autorizado', new Immutable.Map(action.Obj))
		case ACTION_GET_AUTHORIZED_DATE:
			return state.set('get_authorized_date', new Immutable.Map(action.Obj))
			default:
      return state
  }
}

/* Action Creators */

export const getCatalogoMontos = () => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getCatalogoMontos',
      method: 'POST',
      data: {},
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_MONTOS_CHANGE, Obj: response.data })
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getIdtareaChangeDest = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/bpm/getIdtareaChangeDest',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

/** inicar cambio destino ejecutivo */
export const initialChangeDestinity = form => {
  let concepto = []
  form.conceptos.map(d => {
    concepto.push({
      idDonatariaRubro: d.idRubroDonataria,
      concepto: d.concepto,
      montoAutorizado: d.montoAutorizado,
      montoAjusteRecurso: d.ajuste
    })
  })

  let tmp = {
    donataria: {
      idDonataria: form.donataria.id,
      nombreDonataria: form.donataria.nombre,
      correoElectronico: [],
      idCorrida: form.corrida.id,
      descripcionOportunidad: form.corrida.nombre,
      responsableSolicita: form.responsableSolicitud,
      fechaEnvio: form.fechaEnvio ? form.fechaEnvio.slice(0, 10) : new Date().toISOString().slice(0, 10),
      ejecutivo: {
        idUsuario: sessionStorage.uid,
        nombreUsuario: sessionStorage.firstname
      },
      conceptos: {
        concepto
      }
    }
  }

  if (concepto.length === 0) delete tmp.donataria.conceptos

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/bpm/initialChangeDestinity',
      method: 'POST',
      data: { ...tmp },
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.successMessage()))
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

/** para ejecutivo detalle y donataria */
export const initTaskExecutiveGrantees = (form, isExecutive, tag) => {
  let concepto = []
  form.conceptos.map(d => {
    concepto.push({
      idDonatariaRubro: d.idRubroDonataria,
      concepto: d.concepto,
      montoAutorizado: d.montoAutorizado,
      montoAjusteRecurso: d.ajuste
    })
  })

  let resultado = tag

  let ejecutivo = {}

  if (isExecutive) {
    ejecutivo = { idUsuario: sessionStorage.uid, nombreUsuario: sessionStorage.firstname }
  } else {
    ejecutivo = { idUsuario: form.donataria.usuarioEjecutivo }
  }

  let tmp = {
    idTarea: form.idTarea,
    resultado,
    donataria: {
      idDonataria: form.donataria.id,
      nombreDonataria: form.donataria.nombre,
      idCorrida: form.corrida.id,
      descripcionOportunidad: form.corrida.nombre,
      idTarea: form.idTarea,
      responsableSolicita: form.responsableSolicitud,
      fechaEnvio : new Date().toISOString().slice(0,10),
      ejecutivo,
      montoCambioDestino: form.montoCambioDestino,
      montoTotalAutorizado: form.montoAutorizadoTotal,
      montoTotalAjuste: form.ajusteTotal,
      justificacion: form.justificacion //,
      //conceptos: { concepto }
    }
  }
  if (concepto.length === 0) delete tmp.donataria.conceptos

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/bpm/updateTaskChangeDest',
      method: 'POST',
      data: { ...tmp },
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

/** Metodos para supervisor y director */
export const updateTaskSupervisorDirector = (form, isSupervisor/* , isExecutive, tag */) => {

	let donataria = []
	form.map( data =>{

		let obj = {}
		let perfil = {}
		let fechaAutorizacion = ''
		let montos = {}

		if (isSupervisor) {
			perfil.supervisor = {
				idUsuario : sessionStorage.uid,
				nombreUsuario : sessionStorage.firstname
			}
			fechaAutorizacion = data.fechaAutorizacion ? data.fechaAutorizacion.slice(0,10) : ''
		} else {
			perfil.director = {
				idUsuario : sessionStorage.uid,
				nombreUsuario : sessionStorage.firstname
			}
			fechaAutorizacion = data.fechaAutorizacion ? data.fechaAutorizacion.slice(0,10) : new Date().toISOString().slice(0,10)
			montos = {
				montoCambioDestino: data.montoCambioDestino,
				montoTotalAutorizado: data.montoTotalAutorizado,
				montoTotalAjuste: data.montoTotalAjuste
			}
		}

		obj = {
			idDonataria : data.idDonataria,
			nombreDonataria : data.nombreDonataria,
			correoElectronico: [],
			idCorrida : data.idCorrida,
			descripcionOportunidad : data.descripcionOportunidad,
			idTarea : data.idTarea || '',
			//responsableSolicita : data.responsableSolicitud,
			fechaEnvio: new Date().toISOString().slice(0,10),
			...perfil,
			fechaAutorizacion,
			...montos,

			autoriza: data.aprobar ? 1 : data.rechazar ? 0 : 0,
			rolAutorizacion : isSupervisor ? "Supervisor" : "Director",
			autorizacionCambioDestino: data.autorizacionCambioDestino || false
		}
		if (fechaAutorizacion === '' || fechaAutorizacion === null) delete obj.fechaAutorizacion

		if (data.idTarea && (data.aprobar !== null || data.rechazar !== null) ) donataria.push({...obj})

	})

	let tmp = {
		donatarias : {
			donataria
		}
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/bpm/updateTaskSupervisorDirector',
			method: "POST",
			data: {...tmp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return  response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}


export const detailChangeDest = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/detailChangeDest',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_LIST_DETAILS_CHANGE, Obj: response.data })
        return response.data
      })
      .catch(error => {
        console.log(error,'<-----');
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getExacutiveChangeDest = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/bpm/executiveChangeDest',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))

        let tmp = response.data

        if (tmp.donatarias) {
          tmp.donatarias.donataria.map(item => {
            item.nombreCorrida = item.descripcionOportunidad
            item.flagActive = item.idTarea ? true : false
          })
        }

        dispatch({ type: ACTION_GET_LIST_CHANGE, Obj: tmp.donatarias ? tmp.donatarias.donataria : [] })
        return tmp
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getSupervisorChangeDest = form => {
  return dispatch => {
    dispatch(isLoading(true))
    form.perfil_id = 81
    return new ClientHttpRequest({
      service: 'api/bpm/supervisorChangeDest',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        if (response.data.donatarias) {
          let tmp = []
          response.data.donatarias.donataria.map(item => {
            tmp.push({
              id: item.idDonataria,
              nombreCorrida: item.descripcionOportunidad,
              aprobar: item.autorizacionCambioDestino === null ? false : item.autorizacionCambioDestino ? true : false,
              rechazar: item.autorizacionCambioDestino === null ? false : !item.autorizacionCambioDestino ? true : false,

              fechaAutorizacion: item.fechaAutorizacion ? item.fechaAutorizacion : '',
              comentarios: item.autorizacionCambioDestino ? item.comentarios : '',
              motivoRechazo: item.autorizacionCambioDestino ? '' : item.comentarios,
              justificacion: item.justificacion || '',
              estadodescripcion: item.estado.descripcion,
              ...item
            })
          })

          dispatch({ type: ACTION_GET_LIST_SUPERVISOR_CHANGE, Obj: tmp })
          return tmp
        } else {
          dispatch({ type: ACTION_GET_LIST_SUPERVISOR_CHANGE, Obj: [] })
          return []
        }
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getDirectorChangeDest = () => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/bpm/directionChangeDest',
      method: 'POST',
      data: {},
      headers: Object.assign({
        Authorization: sessionStorage.access_token,
        Bpm: sessionStorage.bpm_token,
        uid: sessionStorage.uid
      })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))

        let tmp = Object.assign([], response.data.donatarias ? response.data.donatarias.donataria : [])
        if (response.data.donatarias) {
          response.data.donatarias.donataria.map(item => {
            item.id = item.idDonataria
            item.nombreCorrida = item.descripcionOportunidad
            item.aprobar = item.autorizacionCambioDestino === null ? false : item.autorizacionCambioDestino ? true : false
            item.rechazar = item.autorizacionCambioDestino === null ? false : !item.autorizacionCambioDestino ? true : false
            item.comentarios = item.comentarios ? item.comentarios : item.motivoRechazo ? item.motivoRechazo : ''
            item.motivoRechazo = item.motivoRechazo || ''
            item.justificacion = item.justificacion || ''
          })
        }
        dispatch({ type: ACTION_GET_LIST_DIRECTOR_CHANGE, Obj: tmp })
        return tmp
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const saveSupervisorAndDirector = (form, isSupervisor) => {

	let tmp = []

	form.data.map( data => {

		let jsonDinamyc = {}
		if (data.rechazar ) {
			jsonDinamyc.motivoRechazo = data.motivoRechazo ? data.motivoRechazo : data.comentarios ? data.comentarios : null // decirle a back
		} else if ( data.aprobar && isSupervisor ) {
			jsonDinamyc.comentarioSupervisor = data.comentarios || null
			jsonDinamyc.fechaDeAutorizacion = data.fechaAutorizacion || null
		} else if ( data.aprobar && isSupervisor === false ) {
			jsonDinamyc.comentarioDirector = data.comentarios || null
		}

		if (data.aprobar || data.rechazar) {
			tmp.push({
				aprobado : data.aprobar ? true : data.rechazar ?  false : null,
        correo: data.correo ? true : false,
				corrida : {
					id: data.idCorrida
				},
				donataria : {
					id: data.idDonataria,
				},
				...jsonDinamyc
			})
		}

	})

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: isSupervisor ? 'api/saveSupervisorChange' : 'api/saveDirectorChange' ,
			method: "POST",
			data: {...tmp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const saveGranteesChange = form => {
  let tmp = Object.assign({}, form)
  tmp = Utils.getObjPropsRemove(tmp, ['idEdit', 'ajuste', 'concepto', 'responsable', 'conceptoAjustado'])
  tmp.data = Utils.getObjPropsRemove(tmp.data, ['montoAutorizadoTotal', 'message', 'ajusteTotal', 'autorizacion', 'fechaEnvio'])
  tmp.data.conceptos = Utils.getListPropsOmit(tmp.data.conceptos, ['id', 'ajusteTotal'])

  tmp.data.conceptos.map(item => {
    item.ajustes = item.ajustes.map(d => {
      if (typeof d.idAjuste === 'string') {
        delete d.idAjuste
      }
      d.conceptoAjustadoList = ''
      delete d.conceptoAjustadoList
      delete d.rubroAjustado
			return {...d}
		})
  })

  let temp = {
    ...tmp.data,
    usuario: sessionStorage.uid,
    justificacion: form.justificacion,
    montoCambioDestino: form.montoCambioDestino,
    responsableSolicitud: form.responsableSolicitud
  }

  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/saveGranteesChange',
      method: 'POST',
      data: { ...temp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const saveExecutiveChange = form => {
  let tmp = {
    ...form,
    usuario: sessionStorage.uid
  }
  return dispatch => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: 'api/saveExecutiveChange',
      method: 'POST',
      data: { ...tmp },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const updateStatusChange = (form) => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/changeStatusChange',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_UPDATE_STATUS_CHANGE, Obj: response.data })
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getReportChangeDestination = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getReportChangeDestination',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_REPORT_CHANGE_DESTINATION, Obj: response.data })
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}

export const getMontoAutorizado = form => {
  return dispatch => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/getMontoAutorizado',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
    })
      .request()
      .then(response => {
        dispatch(isLoading(false))
        dispatch({ type: ACTION_GET_MONTO_AUTORIZADO, Obj: response.data })
        return response.data
      })
      .catch(error => {
        dispatch(isLoading(false))
        dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
        throw error
      })
  }
}



// WEBPACK FOOTER //
// ./src/modules/ChangeDestination/ChangeDestination.js